import * as React from 'react';

import { Button, Grid, List, ListItem, ListItemIcon, Spacer, Typography } from '@emburse/ui-core';
import { CheckIcon, Icon } from '@emburse/ui-essentials';

import { ICompanyModel } from '@Shared/models';

interface ISignUpImplementationDescriptionsProps {
  handleSelectImplementation: (value: ICompanyModel['implementation_options']) => void;
  currentOrgIsSelfGuided?: boolean;
}

const ListItemWithCheckbox: React.FC = ({ children }) => (
  <ListItem>
    <ListItemIcon>
      <Icon iconUrl={CheckIcon} />
    </ListItemIcon>
    {children}
  </ListItem>
);

export const SignUpImplementationDescriptions: React.FC<ISignUpImplementationDescriptionsProps> = ({
  handleSelectImplementation,
  currentOrgIsSelfGuided
}) => {
  return (
    <Grid container wrap="nowrap" direction={{ xs: 'column', md: 'row' }} style={{ columnGap: 30, rowGap: 30 }}>
      <Grid item sm={6} style={{ paddingBottom: 24 }}>
        <div className="cardStyle">
          <Typography variant="h5">Self-Guided: Included</Typography>
          <Spacer size={24} />
          <Typography variant="body2">Easily self-activate your Emburse Spend account leveraging:</Typography>
          <Spacer size={16} />
          <Button
            style={{ width: '100%' }}
            disabled={currentOrgIsSelfGuided}
            onClick={() => handleSelectImplementation('self_guided')}
            data-testid="self_guided"
            className="imp-self-guided"
          >
            {currentOrgIsSelfGuided ? 'Current' : 'Select'}
          </Button>
          <Spacer size={24} />
          <List>
            <ListItemWithCheckbox>Dynamic, In-Product Configuration Guides</ListItemWithCheckbox>
            <ListItemWithCheckbox>Live and Recorded Webinar Offerings</ListItemWithCheckbox>
            <ListItemWithCheckbox>Video and Written Help Center Content</ListItemWithCheckbox>
            <ListItemWithCheckbox>Employee Training Content</ListItemWithCheckbox>
          </List>
        </div>
      </Grid>
      <Grid item sm={6} style={{ paddingBottom: 24 }}>
        <div className="cardStyle">
          <Typography variant="h5">Guided: $1,500</Typography>
          <Spacer size={24} />
          <Typography variant="body2">Leverage an Emburse Spend expert to lead a Guided Implementation of your account:</Typography>
          <Spacer size={16} />
          <Button
            style={{ width: '100%' }}
            onClick={() => handleSelectImplementation('guided')}
            data-testid="guided"
            className="imp-guided"
          >
            Select
          </Button>
          <Spacer size={24} />
          <List>
            <ListItemWithCheckbox>30 Day Project Duration</ListItemWithCheckbox>
            <ListItemWithCheckbox>One-on-one configuration support</ListItemWithCheckbox>
            <ListItemWithCheckbox>Best Practice Sharing</ListItemWithCheckbox>
            <ListItemWithCheckbox>Tailored Administrator Training</ListItemWithCheckbox>
          </List>
        </div>
      </Grid>
    </Grid>
  );
};
